import ReportContent from '@app/components/reports/components/report-content';
import ReportMetric from '@app/components/reports/components/report-metric';
import Text from '@shared/components/content/text';
import { useCCFReportResult } from '../../ccf-report-result-context';

export default function SupplyChainLogistics() {
  const {
    result: { supplyChainLogistics },
  } = useCCFReportResult();

  return (
    <ReportContent>
      <>
        <Text variant="reportBody">
          This category covers the emissions from transportation and storage of
          goods in your supply chain, from the point where your suppliers ship
          your purchased goods to you, through to the point where the products
          you sell are consumed by the end customer.
          <br />
          <br />
          This does not include any transportation or storage that occurs in
          vehicles or sites that you manage, as these emissions are accounted
          for in Scope 1 and Scope 2, through fuel and electricity consumed.
        </Text>
        <ReportMetric
          title="Category emissions"
          value={supplyChainLogistics?.totalCategoryEmissionsTonnes ?? 0}
          unit="tCO2e"
          size="lg"
        />
        <div className="flex space-x-2">
          <ReportMetric
            title="Share of Scope 3 emissions"
            value={supplyChainLogistics?.pctOfScopeEmissions ?? 0}
            unit="%"
            size="md"
            className="flex-1"
          />
          <ReportMetric
            title="Share of total emissions"
            value={supplyChainLogistics?.pctOfCompanyEmissions ?? 0}
            unit="%"
            size="md"
            className="flex-1"
          />
        </div>
      </>
      <>
        <div className="space-y-4">
          <Text variant="h3">Upstream vs downstream</Text>
          <Text variant="reportBody">
            The GHG protocol divides transportation and distribution into two
            categories depending on where it occurs in your supply chain.
          </Text>
          <ReportMetric
            title="Upstream transportation and distribution"
            value={supplyChainLogistics?.upstreamTotalEmissionsTonnes ?? 0}
            unit="tCO2e"
            size="md"
          />
          <Text variant="reportBody">
            This covers emissions that occur between your suppliers sites and
            your sites as well as any logistics that you outsource to a
            third-party.
          </Text>
          <ReportMetric
            title="Downstream transportation and distribution"
            value={supplyChainLogistics?.downstreamTotalEmissionsTonnes ?? 0}
            unit="tCO2e"
            size="md"
          />
          <Text variant="reportBody">
            This covers emissions that occur after your clients have received
            the products from you and includes retail storage and any
            transportation to consumer homes.
          </Text>
        </div>
      </>
    </ReportContent>
  );
}
